import "./MedicalPartners.module.css";
import Header from "@/reusable_sections/Header";
import ScoutingNouvelleGeneration from "./sections/ScoutingNouvelleGeneration";
import TheHiddenCostOfMissedLeads from "./sections/TheHiddenCostOfMissedLeads";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function MedicalPartnersPage() {
  return <div>
      <Header />
      <ScoutingNouvelleGeneration />
      <TheHiddenCostOfMissedLeads />
      <GetInTouch />
      <Footer />
    </div>;
}